import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';

import BannerLayout from "../../../layouts/banner";
import {
  Table, Row, Cell
} from '../../../components/table';
import { getRequest } from '../../../../../api/ApiService';

import { getProductRowColor, getProductNameColor } from '../../../../../api/PerformanceFeedback';

class MarketShareStep3 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      products: [],
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    getRequest(`${process.env.REACT_APP_API_URL}team/products/?round_lte=${activeRound}`)
      .then(res => {
        const products = res.body.filter(i => Number(i.round) === roundId);

        this.setState({
          products,
        });
      })
      .catch(err => { });
  }

  render() {
    const { products } = this.state;
    const { previousShownErrors, activeRound, rounds } = this.props;
    const round = rounds.find(i => i.number === activeRound);

    return (
      <BannerLayout
        section="FEEDBACK"
        subSection="MARKET SHARE"
        previousShownErrors={previousShownErrors}
        alertText="Release Date Issue: You didn’t have a product release in the round"
        paragraph2={(
          <Fragment>
            <p>A product needs to be release from design in order for you to manufacture and sell products</p><br />
            <p>Recommendations: Make sure you have at least product released in the active round.</p>
          </Fragment>
        )}
        visual={(
          <Table>
            <Row background="#2a4169">
              <Cell color="#ffffff" />
              <Cell color="#ffffff">Release Date</Cell>
            </Row>
            {products.map((product, index) => {
              let duration = Math.max(
                product.pixels_duration,
                product.sensitivity_duration,
                product.power_duration,
                product.temp_range_duration
              );

              if (round && round.number > 1 && duration >= 12) {
                duration += (round.number - 1) * 12;
              }

              let year = parseInt((duration - 1) / 12, 10);
              let quarter = duration - year * 12;

              year += 1;
              quarter = quarter / 3 + 1;
              if (quarter >= 5) {
                quarter -= 4;
                year += 1;
              }

              if (round && year < round.number) {
                year = round.number;
              }

              const releaseDate = `Year ${year} Q${quarter}`;
              return (
                <Row background={getProductRowColor(index)} key={index}>
                  <Cell color="rgba(0, 27, 59, 0.94)" background={getProductNameColor(index)}>{product.name}</Cell>
                  <Cell
                    percentageWidth="70"
                    color="rgba(0, 27, 59, 0.94)"
                    fontWeight="500"
                    textAlign="center"
                  >
                    {releaseDate}
                  </Cell>
                </Row>
              )
            })}
          </Table>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
          autoHeight: true
        }}
      />
    );
  }

}

export default MarketShareStep3;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step3.js